import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

const NotFound = () => {
  const { theme } = useTheme();
  const tokens = theme.tokens;
  const tc = tokens.colors;

  return (
    <div className="container mx-auto px-4 sm:px-8 pb-12" style={{ fontFamily: tokens.fonts.ui, textAlign: 'left' }}>
      <div style={{
        background: `color-mix(in srgb, ${tc.surface} 82%, transparent)`,
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        border: `1px solid ${tc.gridLine}`,
        borderRadius: 14,
        padding: '40px 36px',
        marginTop: 24,
      }}>
        <div className="mb-6">
          <div style={{
            fontFamily: tokens.fonts.display,
            fontSize: 72,
            fontWeight: 700,
            color: tc.gridLine,
            lineHeight: 1,
            marginBottom: 12,
          }}>404</div>
          <h1 style={{
            fontFamily: tokens.fonts.display,
            fontSize: 26,
            fontWeight: 600,
            color: tc.ink,
            marginBottom: 8,
          }}>Page Not Found</h1>
          <p style={{ color: tc.muted, marginBottom: 24 }}>
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-medium py-2.5 px-5 rounded-lg transition-opacity hover:opacity-80"
            style={{
              background: tc.accent,
              color: tokens.mode === 'dark' ? '#1a1410' : '#fff',
              fontFamily: tokens.fonts.ui,
              fontSize: 14,
              textDecoration: 'none',
            }}
          >
            <i className="fas fa-home"></i>
            Go to Homepage
          </Link>

          <div style={{ fontSize: 13, color: tc.muted, marginTop: 16 }}>
            <p>Or try one of these pages:</p>
            <div className="flex flex-wrap gap-4 mt-3">
              <Link to="/about" style={{ color: tc.accent }} className="hover:underline">About</Link>
              <Link to="/community" style={{ color: tc.accent }} className="hover:underline">Community</Link>
              <Link to="/subscribe" style={{ color: tc.accent }} className="hover:underline">Subscribe</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
